import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { OcInfraModule, OptionParams, ResourceService } from '@diaas/ux-web';
import { CommonService } from '../../services/common.service';
import { AdvGrowlService } from 'primeng-advanced-growl';

@Component({
  selector: 'app-loan-detail',
  templateUrl: './loan-detail.component.html',
  styleUrls: ['./loan-detail.component.scss']
})
export class LoanDetailComponent implements OnInit {
  resourceService: any;
  policyDetails: any;
  productType: any;
  policyType: string;
  rawData: any = {};
  getAllUrlOfPolicyDetails: any;


  columnDefs: { columnDef: string; header: string }[] = [
    { columnDef: 'effective_date', header: 'Effective Date' },
    { columnDef: 'financial_element', header: 'Financial Element' },
    { columnDef: 'impact_dollars', header: 'Impact Dollars' },
    { columnDef: 'current_balance', header: 'Current Balance' },
  ];

  // columnsToDisplay = ['effective_date', 'financial_element', 'impact_dollars', 'current_balance'];
  loanHistoryData: any[] = [];
  isLoanHistoryVisible: boolean = false;

  startDate: Date | null = null;
  endDate: Date | null = null;
  minEndDate: Date | null = null;
  queryParam: string = '';

  @ViewChild('loanHistorySection') loanHistorySection: ElementRef;
  tableData: any[];

  constructor(public commonSerive: CommonService) { }

  ngOnInit(): void {
    this.resourceService = OcInfraModule.AppInjector.get(ResourceService);
    this.policyDetails = this.resourceService.getResourceFromAliasName('policyDetails');
    this.productType = this.policyDetails.response.product_type;

    const { segment_id = '', seq_number = '', file_code = '' } = this.commonSerive.loanDetailClickedData || {};
    this.getAllUrlOfPolicyDetails = this.commonSerive.getAllUrlOfPolicyDetails();

    const loanIndexUrl = this.getAllUrlOfPolicyDetails &&
      this.getAllUrlOfPolicyDetails["/loans/additionalloanindex"] &&
      this.getAllUrlOfPolicyDetails["/loans/additionalloanindex"].href;

    if (segment_id && seq_number && this.commonSerive._T1_WHOLE_LIFE.includes(this.productType)) {
      this.queryParam = this.buildQuery(segment_id, seq_number);
    }

    if (loanIndexUrl) {
      const url = loanIndexUrl + this.queryParam;
      const optionParams = this.getOptionParams("loans", file_code);
      this.invokeAdditionalLoanIndexAPI(url, optionParams.headers);
    }
  }

  buildQuery(segment_id, seq_number): string {
    return `?seg_id=${segment_id}&seq_num=${seq_number}`;
  }

  getOptionParams(alias: string, file_code): OptionParams {
    const optionParams = new OptionParams();
    optionParams.headers = {
      ...OcInfraModule.AppInjector.get(CommonService).getHeaderByAliasName(alias),
      loanFileCode: file_code
    };
    return optionParams;
  }

  invokeAdditionalLoanIndexAPI(url: string, headers: any): void {
    this.commonSerive.getCallback(url, headers).subscribe((response) => {
      if (response) {
        this.rawData = response;
        this.policyType = this.commonSerive._T1_WHOLE_LIFE.includes(this.productType) ? 'traditional' : 'universal';
      }
    }, (error) => {
      OcInfraModule.AppInjector.get(AdvGrowlService).createTimedErrorMessage("Something went wrong, please try again", 'Error', 0);
    });
  }

  // Call Loan History API for "Loan History" , "Search"
  loadLoanHistory(field: string): void {
    const { segment_id = '', seq_number = '', file_code = '' } = this.commonSerive.loanDetailClickedData || {};
    const historyUrl = this.getAllUrlOfPolicyDetails &&
      this.getAllUrlOfPolicyDetails["/loans/loanhistorydetails"] &&
      this.getAllUrlOfPolicyDetails["/loans/loanhistorydetails"].href;

    if (!segment_id || !seq_number || !historyUrl) return;

    if (field === 'loan history') {
      this.queryParam = this.buildQuery(segment_id, seq_number);
    } else if (field === 'search-history') {
      const start = this.startDate ? this.formatDate(this.startDate) : '';
      const end = this.endDate ? this.formatDate(this.endDate) : '';
      this.queryParam = `?seg_id=${segment_id}&seq_num=${seq_number}&startDate=${start}&endDate=${end}`;
    }

    const url = historyUrl + this.queryParam;
    const optionParams = this.getOptionParams("loans", file_code);
    this.invokeLoanHistoryAPI(url, optionParams.headers);
  }

  // Click on Search by loan History
  searchLoanHistory(field: string): void {
    // if (!this.startDate || !this.endDate) return;
    this.loadLoanHistory(field);
  }


  invokeLoanHistoryAPI(url: string, headers: any): void {
    this.commonSerive.getCallback(url, headers).subscribe((response) => {
      if (response && response['_links'] && response['_links'].item) {
        let rawData = response._links.item;
        this.tableData = this.extractData(rawData);
        this.isLoanHistoryVisible = true;

        setTimeout(() => {
          this.loanHistorySection && this.loanHistorySection.nativeElement &&
            this.loanHistorySection.nativeElement.scrollIntoView({ behavior: 'smooth' });
        }, 100);

      }
    }, (error) => {
      OcInfraModule.AppInjector.get(AdvGrowlService).createTimedErrorMessage("Something went wrong, please try again", 'Error', 0);
    });
  }

  formatDate(date: string | Date): string {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${month}/${day}/${year}`;
  }

  // Select min date for End date when selecting Start Date 
  onStartDateChange(date: Date) {
    this.startDate = date;
    this.minEndDate = date;
    if (this.endDate && this.endDate < this.startDate) {
      this.endDate = null;
    }
  }


  extractData(rawData: any[]): any[] {
    if (!rawData && rawData.length) return [];

    return rawData.map((entry: any) => {
      const item = entry.summary;
      const baseData: any = {
        effective_date: item.effective_date ? item.effective_date : '-',
        financial_element: item.financial_element ? item.financial_element : '-',
        impact_dollars: item.impact_dollars ? item.impact_dollars : '-',
        current_balance: item.current_balance ? item.current_balance : '-',
      };

      return baseData;
    });
  }

}
